import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../css/Profile.css";

const ROLE_DASHBOARD = {
  admin:       "/admin",
  parent:      "/parent",
  learner:     "/child",
  educator:    "/educator",
  institution: "/institution",
};

export default function Profile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const name     = localStorage.getItem("name")     || "";
  const username = localStorage.getItem("username") || "";
  const email    = localStorage.getItem("email")    || "";
  const phone    = localStorage.getItem("phone")    || "";
  const role     = user?.role || localStorage.getItem("role") || "";

  if (!user) return <p className="pf-error">No user logged in.</p>;

  const initials = name
    ? name.split(" ").map((w) => w[0]).join("").toUpperCase().slice(0, 2)
    : role.slice(0, 2).toUpperCase();

  const fields = [
    { label: "Full Name",  value: name     || "Not set" },
    { label: "Username",   value: username || "Not set" },
    { label: "Email",      value: email    || "Not set" },
    { label: "Phone",      value: phone    || "Not set" },
    { label: "Role",       value: role,    capitalize: true },
    { label: "Status",     value: "Active", status: true },
  ];

  return (
    <div className="pf-wrapper">
      {/* Header strip */}
      <div className="pf-header">
        <div className="pf-avatar">{initials}</div>
        <div className="pf-header-info">
          <h1 className="pf-title">{name || "Your Account"}</h1>
          <span className="pf-role-badge">{role}</span>
        </div>
      </div>

      {/* Details card */}
      <div className="pf-card">
        <p className="pf-section-label">Account Details</p>
        <table className="pf-table">
          <tbody>
            {fields.map(({ label, value, capitalize, status }) => (
              <tr className="pf-tr" key={label}>
                <td className="pf-td-label">{label}</td>
                <td className={`pf-td-value${capitalize ? " pf-capitalize" : ""}`}>
                  {status
                    ? <span className="pf-status-dot">Active</span>
                    : value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Actions */}
      <div className="pf-actions">
        <button className="pf-btn-back" onClick={() => navigate(ROLE_DASHBOARD[role] || "/")}>
          ← Back to Dashboard
        </button>
        <button className="pf-btn-logout" onClick={logout}>
          Sign Out
        </button>
      </div>
    </div>
  );
}
